import { useSelf } from "../../state/SelfSession";

/** Recovery stays inside the app, including builds without a native menu bar. */
export function CallError({ message }: { message: string }) {
  const self = useSelf();
  return <div role="alert" className="mt-2 max-w-md space-y-2 text-xs">
    <p className="text-rose-500">{message}</p>
    <button type="button" onClick={() => self.openSettings("voice-video")} className="rounded-md border border-cloud-300 px-3 py-2 font-semibold text-cloud-700 hover:bg-cloud-100">Voice &amp; video settings</button>
  </div>;
}
